import { Campaign, CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { transformCampaignApiToCommonFormFields } from './transformCampaignApiToCommonFormFields';
import { DeliveryDiscountFormValues } from '../../types';

export const transformCampaignApiToDeliveryDiscountForm = (
  campaign: Campaign,
  timezone: string,
): DeliveryDiscountFormValues => ({
  ...transformCampaignApiToCommonFormFields(campaign, timezone),
  maxDeliveryDistance: campaign.max_delivery_distance,
  campaignType: CampaignType.DELIVERY_DISCOUNT,
});
